import { type Locale } from '@mfw/translations';

export interface CountryType {
  suggested?: boolean;
  countryCode: string;
  dialCode: string;
  label: string;
}

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
export const countries: readonly CountryType[] = [
  { countryCode: 'AD', dialCode: '376', label: 'Andorra' },
  {
    countryCode: 'AE',
    dialCode: '971',
    label: 'United Arab Emirates',
  },
  { countryCode: 'AF', dialCode: '93', label: 'Afghanistan' },
  {
    countryCode: 'AG',
    dialCode: '1-268',
    label: 'Antigua and Barbuda',
  },
  { countryCode: 'AI', dialCode: '1-264', label: 'Anguilla' },
  { countryCode: 'AL', dialCode: '355', label: 'Albania' },
  { countryCode: 'AM', dialCode: '374', label: 'Armenia' },
  { countryCode: 'AO', dialCode: '244', label: 'Angola' },
  { countryCode: 'AQ', dialCode: '672', label: 'Antarctica' },
  { countryCode: 'AR', dialCode: '54', label: 'Argentina' },
  { countryCode: 'AS', dialCode: '1-684', label: 'American Samoa' },
  { countryCode: 'AT', dialCode: '43', label: 'Austria' },
  {
    countryCode: 'AU',
    dialCode: '61',
    label: 'Australia',
    suggested: true,
  },
  { countryCode: 'AW', dialCode: '297', label: 'Aruba' },
  { countryCode: 'AX', dialCode: '358', label: 'Alland Islands' },
  { countryCode: 'AZ', dialCode: '994', label: 'Azerbaijan' },
  {
    countryCode: 'BA',
    dialCode: '387',
    label: 'Bosnia and Herzegovina',
  },
  { countryCode: 'BB', dialCode: '1-246', label: 'Barbados' },
  { countryCode: 'BD', dialCode: '880', label: 'Bangladesh' },
  { countryCode: 'BE', dialCode: '32', label: 'Belgium' },
  { countryCode: 'BF', dialCode: '226', label: 'Burkina Faso' },
  { countryCode: 'BG', dialCode: '359', label: 'Bulgaria' },
  { countryCode: 'BH', dialCode: '973', label: 'Bahrain' },
  { countryCode: 'BI', dialCode: '257', label: 'Burundi' },
  { countryCode: 'BJ', dialCode: '229', label: 'Benin' },
  { countryCode: 'BL', dialCode: '590', label: 'Saint Barthelemy' },
  { countryCode: 'BM', dialCode: '1-441', label: 'Bermuda' },
  { countryCode: 'BN', dialCode: '673', label: 'Brunei Darussalam' },
  { countryCode: 'BO', dialCode: '591', label: 'Bolivia' },
  { countryCode: 'BR', dialCode: '55', label: 'Brazil' },
  { countryCode: 'BS', dialCode: '1-242', label: 'Bahamas' },
  { countryCode: 'BT', dialCode: '975', label: 'Bhutan' },
  { countryCode: 'BV', dialCode: '47', label: 'Bouvet Island' },
  { countryCode: 'BW', dialCode: '267', label: 'Botswana' },
  { countryCode: 'BY', dialCode: '375', label: 'Belarus' },
  { countryCode: 'BZ', dialCode: '501', label: 'Belize' },
  {
    countryCode: 'CA',
    dialCode: '1',
    label: 'Canada',
    suggested: true,
  },
  {
    countryCode: 'CC',
    dialCode: '61',
    label: 'Cocos (Keeling) Islands',
  },
  {
    countryCode: 'CD',
    dialCode: '243',
    label: 'Congo, Democratic Republic of the',
  },
  {
    countryCode: 'CF',
    dialCode: '236',
    label: 'Central African Republic',
  },
  {
    countryCode: 'CG',
    dialCode: '242',
    label: 'Congo, Republic of the',
  },
  { countryCode: 'CH', dialCode: '41', label: 'Switzerland' },
  { countryCode: 'CI', dialCode: '225', label: "Cote d'Ivoire" },
  { countryCode: 'CK', dialCode: '682', label: 'Cook Islands' },
  { countryCode: 'CL', dialCode: '56', label: 'Chile' },
  { countryCode: 'CM', dialCode: '237', label: 'Cameroon' },
  { countryCode: 'CN', dialCode: '86', label: 'China' },
  { countryCode: 'CO', dialCode: '57', label: 'Colombia' },
  { countryCode: 'CR', dialCode: '506', label: 'Costa Rica' },
  { countryCode: 'CU', dialCode: '53', label: 'Cuba' },
  { countryCode: 'CV', dialCode: '238', label: 'Cape Verde' },
  { countryCode: 'CW', dialCode: '599', label: 'Curacao' },
  { countryCode: 'CX', dialCode: '61', label: 'Christmas Island' },
  { countryCode: 'CY', dialCode: '357', label: 'Cyprus' },
  { countryCode: 'CZ', dialCode: '420', label: 'Czech Republic' },
  {
    countryCode: 'DE',
    dialCode: '49',
    label: 'Germany',
    suggested: true,
  },
  { countryCode: 'DJ', dialCode: '253', label: 'Djibouti' },
  { countryCode: 'DK', dialCode: '45', label: 'Denmark' },
  { countryCode: 'DM', dialCode: '1-767', label: 'Dominica' },
  {
    countryCode: 'DO',
    dialCode: '1-809',
    label: 'Dominican Republic',
  },
  { countryCode: 'DZ', dialCode: '213', label: 'Algeria' },
  { countryCode: 'EC', dialCode: '593', label: 'Ecuador' },
  { countryCode: 'EE', dialCode: '372', label: 'Estonia' },
  { countryCode: 'EG', dialCode: '20', label: 'Egypt' },
  { countryCode: 'EH', dialCode: '212', label: 'Western Sahara' },
  { countryCode: 'ER', dialCode: '291', label: 'Eritrea' },
  { countryCode: 'ES', dialCode: '34', label: 'Spain' },
  { countryCode: 'ET', dialCode: '251', label: 'Ethiopia' },
  { countryCode: 'FI', dialCode: '358', label: 'Finland' },
  { countryCode: 'FJ', dialCode: '679', label: 'Fiji' },
  {
    countryCode: 'FK',
    dialCode: '500',
    label: 'Falkland Islands (Malvinas)',
  },
  {
    countryCode: 'FM',
    dialCode: '691',
    label: 'Micronesia, Federated States of',
  },
  { countryCode: 'FO', dialCode: '298', label: 'Faroe Islands' },
  {
    countryCode: 'FR',
    dialCode: '33',
    label: 'France',
    suggested: true,
  },
  { countryCode: 'GA', dialCode: '241', label: 'Gabon' },
  { countryCode: 'GB', dialCode: '44', label: 'United Kingdom' },
  { countryCode: 'GD', dialCode: '1-473', label: 'Grenada' },
  { countryCode: 'GE', dialCode: '995', label: 'Georgia' },
  { countryCode: 'GF', dialCode: '594', label: 'French Guiana' },
  { countryCode: 'GG', dialCode: '44', label: 'Guernsey' },
  { countryCode: 'GH', dialCode: '233', label: 'Ghana' },
  { countryCode: 'GI', dialCode: '350', label: 'Gibraltar' },
  { countryCode: 'GL', dialCode: '299', label: 'Greenland' },
  { countryCode: 'GM', dialCode: '220', label: 'Gambia' },
  { countryCode: 'GN', dialCode: '224', label: 'Guinea' },
  { countryCode: 'GP', dialCode: '590', label: 'Guadeloupe' },
  { countryCode: 'GQ', dialCode: '240', label: 'Equatorial Guinea' },
  { countryCode: 'GR', dialCode: '30', label: 'Greece' },
  {
    countryCode: 'GS',
    dialCode: '500',
    label: 'South Georgia and the South Sandwich Islands',
  },
  { countryCode: 'GT', dialCode: '502', label: 'Guatemala' },
  { countryCode: 'GU', dialCode: '1-671', label: 'Guam' },
  { countryCode: 'GW', dialCode: '245', label: 'Guinea-Bissau' },
  { countryCode: 'GY', dialCode: '592', label: 'Guyana' },
  { countryCode: 'HK', dialCode: '852', label: 'Hong Kong' },
  {
    countryCode: 'HM',
    dialCode: '672',
    label: 'Heard Island and McDonald Islands',
  },
  { countryCode: 'HN', dialCode: '504', label: 'Honduras' },
  { countryCode: 'HR', dialCode: '385', label: 'Croatia' },
  { countryCode: 'HT', dialCode: '509', label: 'Haiti' },
  { countryCode: 'HU', dialCode: '36', label: 'Hungary' },
  { countryCode: 'ID', dialCode: '62', label: 'Indonesia' },
  { countryCode: 'IE', dialCode: '353', label: 'Ireland' },
  { countryCode: 'IL', dialCode: '972', label: 'Israel' },
  { countryCode: 'IM', dialCode: '44', label: 'Isle of Man' },
  { countryCode: 'IN', dialCode: '91', label: 'India' },
  {
    countryCode: 'IO',
    dialCode: '246',
    label: 'British Indian Ocean Territory',
  },
  { countryCode: 'IQ', dialCode: '964', label: 'Iraq' },
  {
    countryCode: 'IR',
    dialCode: '98',
    label: 'Iran, Islamic Republic of',
  },
  { countryCode: 'IS', dialCode: '354', label: 'Iceland' },
  { countryCode: 'IT', dialCode: '39', label: 'Italy' },
  { countryCode: 'JE', dialCode: '44', label: 'Jersey' },
  { countryCode: 'JM', dialCode: '1-876', label: 'Jamaica' },
  { countryCode: 'JO', dialCode: '962', label: 'Jordan' },
  {
    countryCode: 'JP',
    dialCode: '81',
    label: 'Japan',
    suggested: true,
  },
  { countryCode: 'KE', dialCode: '254', label: 'Kenya' },
  { countryCode: 'KG', dialCode: '996', label: 'Kyrgyzstan' },
  { countryCode: 'KH', dialCode: '855', label: 'Cambodia' },
  { countryCode: 'KI', dialCode: '686', label: 'Kiribati' },
  { countryCode: 'KM', dialCode: '269', label: 'Comoros' },
  {
    countryCode: 'KN',
    dialCode: '1-869',
    label: 'Saint Kitts and Nevis',
  },
  {
    countryCode: 'KP',
    dialCode: '850',
    label: "Korea, Democratic People's Republic of",
  },
  { countryCode: 'KR', dialCode: '82', label: 'Korea, Republic of' },
  { countryCode: 'KW', dialCode: '965', label: 'Kuwait' },
  { countryCode: 'KY', dialCode: '1-345', label: 'Cayman Islands' },
  { countryCode: 'KZ', dialCode: '7', label: 'Kazakhstan' },
  {
    countryCode: 'LA',
    dialCode: '856',
    label: "Lao People's Democratic Republic",
  },
  { countryCode: 'LB', dialCode: '961', label: 'Lebanon' },
  { countryCode: 'LC', dialCode: '1-758', label: 'Saint Lucia' },
  { countryCode: 'LI', dialCode: '423', label: 'Liechtenstein' },
  { countryCode: 'LK', dialCode: '94', label: 'Sri Lanka' },
  { countryCode: 'LR', dialCode: '231', label: 'Liberia' },
  { countryCode: 'LS', dialCode: '266', label: 'Lesotho' },
  { countryCode: 'LT', dialCode: '370', label: 'Lithuania' },
  { countryCode: 'LU', dialCode: '352', label: 'Luxembourg' },
  { countryCode: 'LV', dialCode: '371', label: 'Latvia' },
  { countryCode: 'LY', dialCode: '218', label: 'Libya' },
  { countryCode: 'MA', dialCode: '212', label: 'Morocco' },
  { countryCode: 'MC', dialCode: '377', label: 'Monaco' },
  {
    countryCode: 'MD',
    dialCode: '373',
    label: 'Moldova, Republic of',
  },
  { countryCode: 'ME', dialCode: '382', label: 'Montenegro' },
  {
    countryCode: 'MF',
    dialCode: '590',
    label: 'Saint Martin (French part)',
  },
  { countryCode: 'MG', dialCode: '261', label: 'Madagascar' },
  { countryCode: 'MH', dialCode: '692', label: 'Marshall Islands' },
  {
    countryCode: 'MK',
    dialCode: '389',
    label: 'Macedonia, the Former Yugoslav Republic of',
  },
  { countryCode: 'ML', dialCode: '223', label: 'Mali' },
  { countryCode: 'MM', dialCode: '95', label: 'Myanmar' },
  { countryCode: 'MN', dialCode: '976', label: 'Mongolia' },
  { countryCode: 'MO', dialCode: '853', label: 'Macao' },
  {
    countryCode: 'MP',
    dialCode: '1-670',
    label: 'Northern Mariana Islands',
  },
  { countryCode: 'MQ', dialCode: '596', label: 'Martinique' },
  { countryCode: 'MR', dialCode: '222', label: 'Mauritania' },
  { countryCode: 'MS', dialCode: '1-664', label: 'Montserrat' },
  { countryCode: 'MT', dialCode: '356', label: 'Malta' },
  { countryCode: 'MU', dialCode: '230', label: 'Mauritius' },
  { countryCode: 'MV', dialCode: '960', label: 'Maldives' },
  { countryCode: 'MW', dialCode: '265', label: 'Malawi' },
  { countryCode: 'MX', dialCode: '52', label: 'Mexico' },
  { countryCode: 'MY', dialCode: '60', label: 'Malaysia' },
  { countryCode: 'MZ', dialCode: '258', label: 'Mozambique' },
  { countryCode: 'NA', dialCode: '264', label: 'Namibia' },
  { countryCode: 'NC', dialCode: '687', label: 'New Caledonia' },
  { countryCode: 'NE', dialCode: '227', label: 'Niger' },
  { countryCode: 'NF', dialCode: '672', label: 'Norfolk Island' },
  { countryCode: 'NG', dialCode: '234', label: 'Nigeria' },
  { countryCode: 'NI', dialCode: '505', label: 'Nicaragua' },
  { countryCode: 'NL', dialCode: '31', label: 'Netherlands' },
  { countryCode: 'NO', dialCode: '47', label: 'Norway' },
  { countryCode: 'NP', dialCode: '977', label: 'Nepal' },
  { countryCode: 'NR', dialCode: '674', label: 'Nauru' },
  { countryCode: 'NU', dialCode: '683', label: 'Niue' },
  { countryCode: 'NZ', dialCode: '64', label: 'New Zealand' },
  { countryCode: 'OM', dialCode: '968', label: 'Oman' },
  { countryCode: 'PA', dialCode: '507', label: 'Panama' },
  { countryCode: 'PE', dialCode: '51', label: 'Peru' },
  { countryCode: 'PF', dialCode: '689', label: 'French Polynesia' },
  { countryCode: 'PG', dialCode: '675', label: 'Papua New Guinea' },
  { countryCode: 'PH', dialCode: '63', label: 'Philippines' },
  { countryCode: 'PK', dialCode: '92', label: 'Pakistan' },
  { countryCode: 'PL', dialCode: '48', label: 'Poland' },
  {
    countryCode: 'PM',
    dialCode: '508',
    label: 'Saint Pierre and Miquelon',
  },
  { countryCode: 'PN', dialCode: '870', label: 'Pitcairn' },
  { countryCode: 'PR', dialCode: '1', label: 'Puerto Rico' },
  {
    countryCode: 'PS',
    dialCode: '970',
    label: 'Palestine, State of',
  },
  { countryCode: 'PT', dialCode: '351', label: 'Portugal' },
  { countryCode: 'PW', dialCode: '680', label: 'Palau' },
  { countryCode: 'PY', dialCode: '595', label: 'Paraguay' },
  { countryCode: 'QA', dialCode: '974', label: 'Qatar' },
  { countryCode: 'RE', dialCode: '262', label: 'Reunion' },
  { countryCode: 'RO', dialCode: '40', label: 'Romania' },
  { countryCode: 'RS', dialCode: '381', label: 'Serbia' },
  { countryCode: 'RU', dialCode: '7', label: 'Russian Federation' },
  { countryCode: 'RW', dialCode: '250', label: 'Rwanda' },
  { countryCode: 'SA', dialCode: '966', label: 'Saudi Arabia' },
  { countryCode: 'SB', dialCode: '677', label: 'Solomon Islands' },
  { countryCode: 'SC', dialCode: '248', label: 'Seychelles' },
  { countryCode: 'SD', dialCode: '249', label: 'Sudan' },
  { countryCode: 'SE', dialCode: '46', label: 'Sweden' },
  { countryCode: 'SG', dialCode: '65', label: 'Singapore' },
  { countryCode: 'SH', dialCode: '290', label: 'Saint Helena' },
  { countryCode: 'SI', dialCode: '386', label: 'Slovenia' },
  {
    countryCode: 'SJ',
    dialCode: '47',
    label: 'Svalbard and Jan Mayen',
  },
  { countryCode: 'SK', dialCode: '421', label: 'Slovakia' },
  { countryCode: 'SL', dialCode: '232', label: 'Sierra Leone' },
  { countryCode: 'SM', dialCode: '378', label: 'San Marino' },
  { countryCode: 'SN', dialCode: '221', label: 'Senegal' },
  { countryCode: 'SO', dialCode: '252', label: 'Somalia' },
  { countryCode: 'SR', dialCode: '597', label: 'Suriname' },
  { countryCode: 'SS', dialCode: '211', label: 'South Sudan' },
  {
    countryCode: 'ST',
    dialCode: '239',
    label: 'Sao Tome and Principe',
  },
  { countryCode: 'SV', dialCode: '503', label: 'El Salvador' },
  {
    countryCode: 'SX',
    dialCode: '1-721',
    label: 'Sint Maarten (Dutch part)',
  },
  {
    countryCode: 'SY',
    dialCode: '963',
    label: 'Syrian Arab Republic',
  },
  { countryCode: 'SZ', dialCode: '268', label: 'Swaziland' },
  {
    countryCode: 'TC',
    dialCode: '1-649',
    label: 'Turks and Caicos Islands',
  },
  { countryCode: 'TD', dialCode: '235', label: 'Chad' },
  {
    countryCode: 'TF',
    dialCode: '262',
    label: 'French Southern Territories',
  },
  { countryCode: 'TG', dialCode: '228', label: 'Togo' },
  { countryCode: 'TH', dialCode: '66', label: 'Thailand' },
  { countryCode: 'TJ', dialCode: '992', label: 'Tajikistan' },
  { countryCode: 'TK', dialCode: '690', label: 'Tokelau' },
  { countryCode: 'TL', dialCode: '670', label: 'Timor-Leste' },
  { countryCode: 'TM', dialCode: '993', label: 'Turkmenistan' },
  { countryCode: 'TN', dialCode: '216', label: 'Tunisia' },
  { countryCode: 'TO', dialCode: '676', label: 'Tonga' },
  { countryCode: 'TR', dialCode: '90', label: 'Turkey' },
  {
    countryCode: 'TT',
    dialCode: '1-868',
    label: 'Trinidad and Tobago',
  },
  { countryCode: 'TV', dialCode: '688', label: 'Tuvalu' },
  {
    countryCode: 'TW',
    dialCode: '886',
    label: 'Taiwan',
  },
  {
    countryCode: 'TZ',
    dialCode: '255',
    label: 'United Republic of Tanzania',
  },
  { countryCode: 'UA', dialCode: '380', label: 'Ukraine' },
  { countryCode: 'UG', dialCode: '256', label: 'Uganda' },
  {
    countryCode: 'US',
    dialCode: '1',
    label: 'United States',
    suggested: true,
  },
  { countryCode: 'UY', dialCode: '598', label: 'Uruguay' },
  { countryCode: 'UZ', dialCode: '998', label: 'Uzbekistan' },
  {
    countryCode: 'VA',
    dialCode: '379',
    label: 'Holy See (Vatican City State)',
  },
  {
    countryCode: 'VC',
    dialCode: '1-784',
    label: 'Saint Vincent and the Grenadines',
  },
  { countryCode: 'VE', dialCode: '58', label: 'Venezuela' },
  {
    countryCode: 'VG',
    dialCode: '1-284',
    label: 'British Virgin Islands',
  },
  {
    countryCode: 'VI',
    dialCode: '1-340',
    label: 'US Virgin Islands',
  },
  { countryCode: 'VN', dialCode: '84', label: 'Vietnam' },
  { countryCode: 'VU', dialCode: '678', label: 'Vanuatu' },
  { countryCode: 'WF', dialCode: '681', label: 'Wallis and Futuna' },
  { countryCode: 'WS', dialCode: '685', label: 'Samoa' },
  { countryCode: 'XK', dialCode: '383', label: 'Kosovo' },
  { countryCode: 'YE', dialCode: '967', label: 'Yemen' },
  { countryCode: 'YT', dialCode: '262', label: 'Mayotte' },
  { countryCode: 'ZA', dialCode: '27', label: 'South Africa' },
  { countryCode: 'ZM', dialCode: '260', label: 'Zambia' },
  { countryCode: 'ZW', dialCode: '263', label: 'Zimbabwe' },
];

export function getLocalizedCountry(
  locale: Locale,
  country: { value: string; label: string },
) {
  const displayNames = new Intl.DisplayNames(locale, { type: 'region' });
  return {
    label: displayNames.of(country.value),
    value: country.value,
  };
}

export function getCountriesByLocale(locale: Locale) {
  const displayNames = new Intl.DisplayNames(locale, { type: 'region' });

  return countries.map((country) => ({
    ...country,
    label: displayNames.of(country.countryCode),
  }));
}
